import { ServiceTypeDto } from '@interfaces/ServiceTypeDto';

export class ServiceTypePickerItem {
  public code: string;
  public description: string;

  public constructor(st: ServiceTypeDto) {
    this.code = st.code;
    this.description = st.description;
  }
}
